import React, { Component } from 'react';
import { Confirm, Container, Dropdown, Grid, Header, Search, Segment, Icon, Dimmer, Loader, Form, Label, Message } from 'semantic-ui-react';
import { getAllSpecialities, searchSubscribedSeller, getAllBadges, getSellerDetailedProfile, updateSellerProfile, deleteSellerGalleryImage, addImagesToSellerGallery, getSellerGallery, getSellerPlanCategories, getCategorySpecialities, uploadSellerImage, getSellerImage } from 'services/Manager';
import DGTextBox from 'components/FormControls/Textbox/DGTextbox'
import './UpdateSellerContainer.less'
import DGTextarea from 'components/FormControls/Textarea/DGTextarea';
import Formsy from 'formsy-react';
import DGUploadFile from 'components/FormControls/UploadFile/DGUploadFile';
import fileUploadRemove from '../../assets/images/newui/remove-img.svg'
import _ from 'lodash';
import DGCheckbox from 'components/FormControls/Checkbox/DGCheckbox';
import GeneralError from 'components/GeneralError/GeneralError';
import Config from 'Config'
import { getSellerUrl } from '../../helpers/sellerAddress';


const inititalState = {
    searchingSellers: false,
    aboutSellerExisting: '',
    aboutSellerNew: null,
    sellers:[],
    specialitiesMasterList: [],
    specialitiesDisplayList: [],
    badges: [],
    sellerBadges: [],
    sellerSpecialities: [],
    sellerID: 0,
    sellerGalleries: [],
    showImageDeletionConfirmation: false,
    sellerGalleryID: 0,
    deleteImageIDs: [],
    uploadFiles: [],
    updating: false,
    searchSellerPhrase: '',
    isProfilePublished: false,
    showBadgeError: false,
    showSpecialityError: false,
    specialityError: '',
    badgeError: '',
    sellerPlanCategories: [],
    updateError: '',
    avatarImage: null,
    avatarImageUpload: null,
    showChangeSellerConfirmation: false,
    newSearchResultID: 0,
    sellerUrl: '',
    profileSaved: false,
    sellerCity : '',
    sellerStateName : '',
    sellerStateAbbreviation : '',
    sellerAddressline1 : '',
    sellerZip : '',
    sellerTOSLink : '',
    seoName: ''
}
class UpdateSellerContainer extends Component {

    constructor(props){
        super(props);
        this.state = inititalState;
        this.searchRef = React.createRef();
    }

    componentDidMount(){
        
        this.getAllBadges();
        

        
    }



    getAllBadges = async () => {
        const badgesRes = await getAllBadges();
        
        if(badgesRes && badgesRes.resStatus == 200){
            let badges = [];
            badgesRes.data.map((badge) => {
                badges.push({text: badge.name, value: badge.badgeID});
            })
            this.setState({badges: badges}, () => {
                
            })
        }
    }

    getCategorySpecialities = async (categories) => {
        const specialitiesRes = await getCategorySpecialities(categories);
        if(specialitiesRes && specialitiesRes.resStatus == 200){
            let specialities = [];
            specialitiesRes.data.map((speciality) => {
                specialities.push({text: speciality.name, value: +speciality.categorySpecialityID});
            })
            this.setState({specialitiesMasterList: specialities}, () => {
                this.filterSpecialityDisplayList();
            });
        }
    }

    filterSpecialityDisplayList = () => {
        const selectedSpecialitiesIDList = _.map(this.state.sellerSpecialities, 'categorySpecialityID');
        let displaySpecialities = [...this.state.specialitiesMasterList];

        _.remove(displaySpecialities, (ds) => {
            return selectedSpecialitiesIDList.includes(ds.value);
        })
        this.setState({specialitiesDisplayList: displaySpecialities});
    }

    getAllSpecialities = async () => {
        const specialitiesRes = await getAllSpecialities();
        if(specialitiesRes && specialitiesRes.resStatus == 200){
            let specialities = [];
            specialitiesRes.data.map((speciality) => {
                specialities.push({text: speciality.name, value: speciality.categorySpecialityID});
            })
            this.setState({specialities: specialities})
        }
    }

    

    onAboutChange = (e, {value}) => {
        this.setState({aboutSellerNew: value});
    }

    onPublishChange = (e, {value}) => {
        this.setState({isProfilePublished: value});
    }

    loadProfile = async (sellerID) => {
        const sellerProfileRes = await getSellerDetailedProfile(sellerID);
        if(sellerProfileRes && sellerProfileRes.resStatus == 200){
            console.log(sellerProfileRes);
            
            this.setState({
                aboutSellerExisting: sellerProfileRes.data.about || '',
                aboutSellerNew: sellerProfileRes.data.about || '',
                sellerBadges: !_.isEmpty(sellerProfileRes.data.badges) ? _.map(sellerProfileRes.data.badges, 'badgeID') : [],
                sellerSpecialities: !_.isEmpty(sellerProfileRes.data.specialities) ? sellerProfileRes.data.specialities : [],
                sellerID: sellerProfileRes.data.sellerID,
                sellerGalleries: sellerProfileRes.data.galleries,
                searchSellerPhrase: sellerProfileRes.data.name,
                isProfilePublished: sellerProfileRes.data.isProfilePublished || false,
                avatarImage: sellerProfileRes.data.avatar,
                sellerUrl: getSellerUrl(sellerProfileRes.data),
                sellerCity : sellerProfileRes.data.city,
                sellerStateName : sellerProfileRes.data.stateName,
                sellerStateAbbreviation : sellerProfileRes.data.stateAbbreviation,
                sellerAddressline1 : sellerProfileRes.data.addressline1,
                sellerZip : sellerProfileRes.data.zip,
                sellerTOSLink : !_.isEmpty(sellerProfileRes.data.tosLink) ? sellerProfileRes.data.tosLink : '',
                seoName: sellerProfileRes.data.seoName
            }, async () => {
                console.log(this.state.sellerUrl);
                const res = await getSellerPlanCategories(this.state.sellerID);
                if(res.resStatus == 200){
                    const sellerPlanCategories = res.data;
                    let categories = [];
                    sellerPlanCategories.map((sellerPlanCategory) => {
                        categories.push({text: sellerPlanCategory.name, value: sellerPlanCategory.categoryID});
                    });
                    this.setState({sellerPlanCategories: categories}, () => {
                        const categoryIDList = _.map(sellerPlanCategories, 'categoryID');
                        this.getCategorySpecialities(categoryIDList);
                        
                    });
                }
            });
        }
    }

    onSellerSelect = async (e, {result}) => {
        if(this.state.sellerID > 0){
            this.setState({showChangeSellerConfirmation: true, newSearchResultID: result.id});
        }
        else{
            await this.loadProfile(result.id);
        }
        
    }

    getSellerDetailedProfile = async () => {

    }

    onSearchSellerChange = (e, {value}) => {
        this.setState({searchSellerPhrase: value, searchingSellers: true});
        if (this.searchSellerTimer)
            clearTimeout(this.searchSellerTimer);

        this.searchSellerTimer = setTimeout(() => {
            if (this.state.searchSellerPhrase.length > 0) {
                searchSubscribedSeller(this.state.searchSellerPhrase).then((response) => {
                    if (response.resStatus === 200) {
                        let sellers = [];
                        response.data.map((seller) => {
                            sellers.push({ id: seller.sellerID, title: seller.name, seoName: seller.seoName });
                        })

                        this.setState({ sellers: sellers });
                    }

                    this.setState({ searchingSellers: false });
                    
                });
            }
            else{
                this.setState({ sellers: [], selectedSeller: {}, searchingSellers: false });
            }
        
        }, 600);

    }

    updateProfile = async () => {

        let isError = false;
        this.setState({specialityError: '',  showSpecialityError: false
        ,badgeError: '',  showBadgeError: false, updateError: false, profileSaved: false});

            if(this.state.sellerSpecialities.length == 0){
                this.setState({specialityError: 'Please provide specialities',  showSpecialityError: true});
                isError = true;
            }

            if(this.state.sellerBadges.length == 0){
                this.setState({badgeError: 'Please provide badges',  showBadgeError: true});
                isError = true;
            }

            

        if (isError) {
            return;
        }

        this.setState({ updating: true });
        let sellerProfile = {};
        if (this.state.aboutSellerExisting != this.state.aboutSellerNew) {
            sellerProfile.about = this.state.aboutSellerNew;
        }
        if (this.state.sellerSpecialities && this.state.sellerSpecialities.length > 0) {
            sellerProfile.specialities = _.map(this.state.sellerSpecialities, 'categorySpecialityID');
        }

        if (this.state.sellerBadges && this.state.sellerBadges.length > 0) {
            sellerProfile.badges = this.state.sellerBadges;
        }

        sellerProfile.isProfilePublished = this.state.isProfilePublished;

        const updateSellerProfileRes = await updateSellerProfile(this.state.sellerID, sellerProfile);
        
        if (updateSellerProfileRes.resStatus == 200) {
            const sellerUrl = getSellerUrl(updateSellerProfileRes.data)
            this.setState({ updating: false, profileSaved: true, sellerUrl: sellerUrl });
        }
        else {
            this.setState({ updating: false, profileSaved: false, updateError: 'Error updating profile' });
        }
    }

    onSpecialityChange = (e, data) => {

        const speciality = _.first(_.filter(this.state.specialitiesMasterList, (s) => {
            return (s.value == data.value[0])
        }));

        let sellerSpecialities = [...this.state.sellerSpecialities];
        sellerSpecialities.push({categorySpecialityID: speciality.value, name: speciality.text});
        this.setState({sellerSpecialities: sellerSpecialities}, () => {
            this.filterSpecialityDisplayList();
        });
    }

    onRemoveSpeciality = (specialityID) => {
        let sellerSpecialities = [...this.state.sellerSpecialities];
        _.remove(sellerSpecialities, (s) => {
            return (s.categorySpecialityID == specialityID);
        })
        
        this.setState({sellerSpecialities: sellerSpecialities}, () => {
            this.filterSpecialityDisplayList();
        })
    }

    onBadgeChange = (e, data) => {
        this.setState({sellerBadges: data.value})
    }

    onGalleryUploadFile = (sellerGalleryID, files) => {
        this.setState({sellerGalleryID: sellerGalleryID, uploadFiles: files});
    }

    onGalleryRemoveFile = (sellerGalleryID, files) => {
        
    }

    removeSellerGalleryImage = (sellerGalleryID, imageID) => {
        console.log(sellerGalleryID, imageID);
        let deleteImageIDs = [];
        deleteImageIDs.push(imageID);
        
        this.setState({ showImageDeletionConfirmation: true, sellerGalleryID: sellerGalleryID, deleteImageIDs: deleteImageIDs });
    }

    onConfirmImageDeletion = async () => {
        const deleteResponse = await deleteSellerGalleryImage(this.state.sellerGalleryID, this.state.deleteImageIDs);
        if(deleteResponse.resStatus == 200){
            
            const [sellerGallery] = _.filter(this.state.sellerGalleries, (gallery) => {
                return gallery.sellerGalleryID == this.state.sellerGalleryID;
            });

            if(sellerGallery){
                _.remove(sellerGallery.images, (image) => {
                    return this.state.deleteImageIDs.includes(image.imageID);
                })
            }
            
            this.setState({ showImageDeletionConfirmation: false, sellerGalleryID: 0, deleteImageIDs: [] });
        }
    }

    onCategoryChange = async (e, {value}) => {
        let categoryIDList = [];
        if(value.length == 0){
            categoryIDList = _.map(this.state.sellerPlanCategories, 'value');
        }
        else{
            categoryIDList = value;
        }
        this.getCategorySpecialities(categoryIDList);
        
    }

    uploadGalleryImages = async () => {
        this.setState({updating: true});
        let formData = new FormData();
        this.state.uploadFiles.map((photo) => {
            formData.append('photos', photo, photo.name);
        });
        
        const uploadImageResponse = await addImagesToSellerGallery(this.state.sellerGalleryID, formData);
        if(uploadImageResponse.resStatus == 200){
            const sellerGalleryResponse = await getSellerGallery(this.state.sellerGalleryID);
            if(sellerGalleryResponse.resStatus == 200){
                const sellerGalleries = [...this.state.sellerGalleries];
                
                const galleryIndex = _.findIndex(sellerGalleries, (gallery) => {
                    return gallery.sellerGalleryID == this.state.sellerGalleryID;
                });
                
                if(galleryIndex >= 0 ){
                    sellerGalleries[galleryIndex] = sellerGalleryResponse.data;
                    this.setState({sellerGalleries: sellerGalleries, sellerGalleryID:0, uploadFiles: [], updating: false});
                }
            }
        }
    }

    handleSellerSelectionReset = () => {
        this.setState({showChangeSellerConfirmation: true, newSearchResultID: 0});
        //this.setState(inititalState);
        
    }

    onConfirmChangeSeller = async () => {
        if (this.state.newSearchResultID > 0) {
            await this.loadProfile(this.state.newSearchResultID);
            this.setState({ showChangeSellerConfirmation: false, newSearchResultID: 0 });
        }
        else {
            const resetState = {...inititalState};
            delete resetState.badges;  
            this.setState(resetState);
        }
    }

    onAvatarUpload = ([file]) => {
        this.setState({avatarImageUpload: file});
    }

    onAvatarRemove = () => {
        this.setState({avatarImageUpload: null});
    }

    uploadAvatar = async () => {
        this.setState({updating: true});
        let formData = new FormData();
        formData.append('image', this.state.avatarImageUpload, this.state.avatarImageUpload.name);
        
        
        const uploadImageResponse = await uploadSellerImage(this.state.sellerID, formData);
        if(uploadImageResponse.resStatus == 200){
            const sellerImageResponse = await getSellerImage(this.state.sellerID);
            if (sellerImageResponse.resStatus == 200) {

                this.setState({ avatarImage: sellerImageResponse.data.avatar, avatarImageUpload: null, updating: false });

            }
        }
    }
    onCopyClick = ()=>{
        if (navigator.clipboard) {
            navigator.clipboard.writeText(this.state.sellerTOSLink)
               
        }
    }

    render() {
        
        return (
            <Dimmer.Dimmable as={Container} className="update-seller-profile-container">
                <Dimmer active={this.state.updating}>
            <Loader inverted>Loading</Loader>
          </Dimmer>
            
            {/*<Container className="update-seller-profile-container">*/}
                <Confirm centered content="Do you really want to remove the image?" className="confirm" 
                open={this.state.showImageDeletionConfirmation}
                onClose={()=> {this.setState({showImageDeletionConfirmation: false})}}
                onCancel={()=> {this.setState({showImageDeletionConfirmation: false})}}
                onConfirm={this.onConfirmImageDeletion}
                 />

                <Confirm centered content="All the changes to the profile will be discarded. Do you want to continue?" className="confirm" 
                open={this.state.showChangeSellerConfirmation}
                onClose={()=> {this.setState({showChangeSellerConfirmation: false})}}
                onCancel={()=> {this.setState({showChangeSellerConfirmation: false})}}
                onConfirm={this.onConfirmChangeSeller}
                 />
                {!_.isEmpty(this.state.updateError) && <GeneralError message={this.state.updateError} /> }
                <Segment padded>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={16}>
                                <Segment padded>
                                    <Header as="h1">Select Business</Header>
                                    <div style={{position:'relative', width: '50%', display: 'inline-block'}}>
                                    <Search 
                                    fluid 
                                    className="seller-search search-box" 
                                    loading={this.state.searchingSellers} 
                                    minCharacters={1} 
                                    onSearchChange={this.onSearchSellerChange} 
                                    results={this.state.sellers}
                                    onResultSelect = {this.onSellerSelect}
                                    value={this.state.searchSellerPhrase}
                                    
                                     />
                                     {this.state.sellerID > 0 && <Icon onClick={this.handleSellerSelectionReset} className='reset-btn' name='close' />}
                                     
                                     </div>
                                     
                                     {
                                        
                                         this.state.sellerID > 0 && this.state.sellerUrl && <div style={{ display: 'inline-block', width: '50%', textAlign: 'right'}}>
                                             <a className="profile-link" href={`${Config.buyerApp.url}${this.state.sellerUrl}`} target="_blank">View Published Profile</a>
                                         </div>
                                     }
                                     {
                                        this.state.sellerID > 0 && <div className="seo-name"><span>SEO Name: </span><span>{this.state.seoName}</span></div>
                                     }
                                </Segment>
                                {
                                    _.isEmpty(this.state.sellerTOSLink) ? "" :
                                    <Segment padded>
                                            <Grid.Row>
                                                <Grid.Column width={16}>
                                                    <Grid><Grid.Row columns={2}>
                                                        <Grid.Column className='tos-status-label' computer={10}>
                                                            <Header>TOS Status : Not Signed
                                                            </Header>
                                                        </Grid.Column>
                                                        <Grid.Column computer={6}>
                                                            <Header><button className="button-submit btn-Copy" onClick={this.onCopyClick}>Copy TOS Link</button>
                                                            </Header>
                                                        </Grid.Column>
                                                    </Grid.Row></Grid>
                                                </Grid.Column>
                                            </Grid.Row>
                                    </Segment>
                                }
                                {
                                    this.state.sellerID == 0 ? "" : 
                                    <Segment padded>
                                        <Grid.Row>
                                            <Grid.Column width={16}>
                                                <Header>{this.state.sellerID == 0 ? "" : this.state.sellerAddressline1 + ", " + this.state.sellerCity + ", " + this.state.sellerStateAbbreviation + " " + this.state.sellerZip}                         
                                                </Header>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Segment>
                                }
                                
                                <Segment padded>
                                <Header>Business Profile Image</Header>
                                 {this.state.avatarImage && <div className="avatar-container"><div className="avatar"><img src={this.state.avatarImage.URL} /></div></div> }
                                    <DGUploadFile fileType="images" value={this.state.avatarImageUpload} {...{
                                        disabled: this.state.sellerID == 0
                                    }}
                                        mainmessage="Upload business profile image by dropping image file here"
                                        submessage=" "

                                        onDrop={(file) => this.onAvatarUpload(file)}
                                        onRemove={(files) => this.onAvatarRemove()}
                                    />
                                    {this.state.avatarImageUpload && <button disabled={this.state.updating} type="button" onClick={this.uploadAvatar} className="button-submit">Upload Image</button> }
                                </Segment>
                                <Segment>
                                    <Formsy onValidSubmit={this.updateProfile}>
                                        <Grid padded>
                                        
                                            <Grid.Row>
                                                <Grid.Column width={16}>
                                                    <Header>About Seller</Header>
                                                </Grid.Column>
                                                <Grid.Column width={16}>
                                                    <DGTextarea required
                                                        disabled={this.state.sellerID == 0}
                                                        label="Enter details about seller"
                                                        name="about"
                                                        value={this.state.aboutSellerExisting}
                                                        //defaultValue={this.state.aboutSellerExisting}
                                                        onChange={this.onAboutChange}
                                                        validationErrors={{
                                                            isDefaultRequiredValue: 'This field is required',

                                                        }}
                                                    />
                                                </Grid.Column>
                                            </Grid.Row>
                                            <Grid.Row>
                                            <Grid.Column width={16}>
                                            <Header >Badges</Header>
                                            </Grid.Column>
                                                <Grid.Column width={16}>
                                                
                                                    <Dropdown placeholder="Select Badges" fluid selection multiple
                                                    name="badges" 
                                                    options={this.state.badges} 
                                                    value={this.state.sellerBadges} 
                                                    onChange={this.onBadgeChange}
                                                    disabled={this.state.sellerID == 0}
                                                    />
                                                    {this.state.showBadgeError && <div className="error-label" >{this.state.badgeError}</div> }
                                                </Grid.Column>
                                            </Grid.Row>
                                            <Grid.Row>
                                            <Grid.Column width={16}>
                                            <Header>Specialities</Header>
                                            </Grid.Column>
                                                <Grid.Column width={16}>
                                                    <Dropdown placeholder="Filter Work Focus/Specialities by Categories" fluid selection multiple
                                                    name="categories" 
                                                    options={this.state.sellerPlanCategories} 
                                                    onChange={this.onCategoryChange}
                                                    disabled={this.state.sellerID == 0}
                                                    />
                                                    {/*this.state.showBadgeError && <div className="error-label" >{this.state.badgeError}</div> */}
                                                </Grid.Column>
                                            </Grid.Row>
                                            
                                            <Grid.Row>
                                                <Grid.Column width={16}>
                                                    <Dropdown placeholder={this.state.specialitiesDisplayList.length == 0 ? "No specialities found" : "Select Specialities"} 
                                                    fluid selection multiple
                                                    name="specialities"
                                                    options={this.state.specialitiesDisplayList}
                                                    value={[]}
                                                    onChange={this.onSpecialityChange}
                                                    disabled={this.state.sellerID == 0}
                                                      />
                                                     {this.state.showSpecialityError && <div className="error-label" >{this.state.specialityError}</div> }
                                                </Grid.Column>
                                            </Grid.Row>
                                            {
                                                this.state.sellerSpecialities && this.state.sellerSpecialities.length > 0 &&
                                                <Grid.Row>
                                                    <Grid.Column width={16}>
                                                        <Segment padded className="selected-segment">
                                                        <div className="label">Selected Specialities</div>
                                                        {
                                                            this.state.sellerSpecialities.map((s) => {
                                                                return <a class="ui label selected" value="1">{s.name}<i aria-hidden="true" class="delete icon" onClick={() => this.onRemoveSpeciality(s.categorySpecialityID)}></i></a>
                                                                
                                                                
                                                            })
                                                        }
                                                        </Segment>
                                                    </Grid.Column>
                                                </Grid.Row>
                                            }
                                            
                                            <Grid.Row>
                                                <Grid.Column width={16}>
                                                    <DGCheckbox name="profilePublished" 
                                                    label="Publish this profile" 
                                                    disabled={this.state.sellerID == 0}
                                                    value={this.state.isProfilePublished}
                                                    onChange={this.onPublishChange}></DGCheckbox>
                                                </Grid.Column>
                                            </Grid.Row>
                                            
                                            {
                                                this.state.profileSaved && <Grid.Row>
                                                    <Grid.Column width={16}>

                                                        <Message positive>
                                                            <Message.Header>Profile Saved</Message.Header>
                                                            <p>
                                                                Your changes have been saved successfully
                                                            </p>
                                                        </Message>
                                                    </Grid.Column>
                                                </Grid.Row>
                                            }
                                                <Grid.Row>
                                                <Grid.Column width={16}>
                                                    <button disabled={this.state.updating || this.state.sellerID == 0} type="submit" className="button-submit">Update Profile</button>
                                                </Grid.Column>
                                            </Grid.Row> 
                                            </Grid>   
                                            
                                            
                                            
                                        
                                    </Formsy>
                                </Segment>
                                {!_.isEmpty(this.state.sellerGalleries) &&
                                                
                                                <Segment padded>
                                                <Grid>
                                                {
                                                    this.state.sellerGalleries.map((gallery) => {
                                                    return <Grid.Row>
                                                        <Grid.Column width={16}>
                                                            <div className="project">
                                                                <div className="heading">
                                                                    {gallery.name}
                                                                </div>
                                                                <div className="gallery">
                                                                    
                                                                    <div className="images">
                                                                        {gallery.images.map(image => {
                                                                            return <div>
                                                                            <img id={`image_${gallery.sellerGalleryID}_${image.imageID}`} src={image.URL} className="gallery-img" />
                                                                            <img src={fileUploadRemove} className="gallery-img-remove" onClick={() => this.removeSellerGalleryImage(gallery.sellerGalleryID, image.imageID)} />
                                                                            </div>
                                                                        })}

                                                                        
                                                                    </div>
                                                                    <div>
                                                                        <DGUploadFile fileType="images" value={this.state.uploadFiles} multiple
                                                                            onDrop={(files) => this.onGalleryUploadFile(gallery.sellerGalleryID, files)}
                                                                            onRemove={(files) => this.onGalleryRemoveFile(gallery.sellerGalleryID, files)}
                                                                        />
                                                                        {this.state.uploadFiles && this.state.uploadFiles.length > 0 && <button disabled={this.state.updating} type="button" onClick={this.uploadGalleryImages} className="button-submit">Upload Photos</button> }
                                                                    </div>
                                                                </div>
                                                                
                                                            </div>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                })
                                                }
                                                </Grid>
                                                </Segment>
                                            }
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Segment>
            {/*</Container>*/}
            </Dimmer.Dimmable>
        )
    }
}

export default UpdateSellerContainer
